// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAmENiH-trh826fZgMLQ9axQ5t1KB57OWI",
    authDomain: "timesheet-converter-f92c8.firebaseapp.com",
    projectId: "timesheet-converter-f92c8",
    storageBucket: "timesheet-converter-f92c8.appspot.com",
    messagingSenderId: "688333375234",
    appId: "1:688333375234:web:2954294efcdb99ab11a41b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app